/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const digipass_corporate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={18}
    fill="none"
    viewBox="0 0 16 18"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2.06 6.505c-.333 5.014.61 10.245 5.961 10.245s6.272-5.23 5.91-10.245m-11.872 0c.064-.962.203-3.173.344-4.389a.863.863 0 0 1 .629-.739c1-.274 2.823-.627 4.99-.627 2.161 0 3.94.352 4.91.626.336.095.575.38.618.727.147 1.179.301 3.312.374 4.317l.006.085m-11.87 0c.792.202 3.191.605 6.023.605s5.078-.403 5.847-.605M5.6 3.95h4.8"
    />
  </svg>
)
export default digipass_corporate
